export default "__VITE_ASSET__AO5xBP7y__"